<div class="podp-dialog">
  <div class="podp-dialog__header">
    <span class="podp-dialog__title" [title]="data.name">{{ data.name }}</span>
    <button type="button" class="podp-dialog__close" (click)="close()">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  </div>
  <iframe *ngIf="!isImage" [src]="safeUrl" class="podp-dialog__frame" title="Document Preview"></iframe>
  <div *ngIf="isImage" class="podp-dialog__image-wrap">
    <img [src]="safeUrl" class="podp-dialog__image" [alt]="data.name" />
  </div>
</div>
